const DeviceDetector = () => {
  const userAgent = navigator.userAgent;

  const isAndroid = /Android/.test(userAgent);
  const isIOS = /iPhone|iPad|iPod/.test(userAgent);
  const isPC = !isAndroid && !isIOS;

  return isPC;
};

export default DeviceDetector;
